module.exports = __webpack_public_path__ + "img/bath-solid.2d67728f.svg";